export default __webpack_public_path__ + "84ae2baa05dbeae55d89992dfbda00b4.png";